import { useState } from 'react'
import css from './index.module.css';
import Content from '@components/adminNavigation';
import axios from "axios";
import { toast } from 'sonner';
import SEO from '@components/seo';

export default function Notifications() {
  const [title, setTitle] = useState('');
  const [notificationMessage, setNotificationMessage] = useState('');

  const handleSendMessage = (event: any) => {
    event.preventDefault();

    axios.post(`${import.meta.env.VITE_API_ADM_URL}/broadcast`, { title: title, message: notificationMessage }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    })
    .then(_ => {
      toast.success('Рассылка отправлена')
      setTitle('');
      setNotificationMessage('');
    })
    .catch(error => {
      console.log(error);
      toast.error('Ошибка отправки рассылки');
    });
  };

  return (
    <Content>
        <SEO 
            title={'Управление рассылками'}
            description={'Админ-панель'}
            ogUrl={`https://рыбныимир.рф`}
        />

        <h1 className={css.head}>Рассылки</h1>

        <div className={css.sendMessageContainer}>
            <b>Отправить рассылку</b>
            <input name='title' type='text' placeholder='Заголовок' value={title} onChange={(e) => setTitle(e.target.value)} />
            <textarea name='notificationMessage' placeholder='Сообщение' value={notificationMessage} onChange={(e) => setNotificationMessage(e.target.value)} />
            <button className={css.sendMessageBtn} type='button' onClick={handleSendMessage}>Отправить рассылку</button>
            <span className={css.note}>Обратите внимание, что рассылка будет отправлена всем пользователям, которые зарегистрированы в системе.</span>
        </div>
    </Content>
  );
}
